import Resources from './helpers/resources';
import {
    makeFormDataRequest,
    getServiceUrl,
    objectToFormData,
    API_URLS
} from './helpers/api-utils';

/**
 * COUNTRIES
 */
export const getCountries = () =>
    (Resources.countries
        .get()
        .send());
export const getStatesByCountry = ({ countryCode }) =>
    (Resources.countryStates)
        .get({ countryCode })
        .send();

/**
 * PUBLICATIONS
 */
export const getPublications = ({ accessStatus, countryCode, state }) =>
    (Resources.publications)
        .post()
        .withBody({ accessStatus, countryCode, state })
        .send();

export const getPublicationsByCountry = ({ countryCode }) =>
    (Resources.countryPublications)
        .get({ countryCode })
        .send();

/**
 * DOCUMENTS
 */
export const getDocumentsByPublication = ({ publicationId }) =>
    (Resources.publicationDocuments)
        .get({ publicationId })
        .send();

/**
 * SECTIONS
 */
export const getSectionsByDocument = ({ documentId }) =>
    (Resources.documentSections)
        .get({ documentId })
        .send();
export const getSectionDetail = ({ sectionId }) =>
    (Resources.sectionDetail)
        .get({ sectionId })
        .send();

/**
 * MASTER COURSES
 */
export const getMasterCoursesByCountry = ({ countryCode }) =>
    (Resources.masterCourses)
        .get()
        .withParams({ countryCode })
        .send();
export const getCountriesWithMasterCourses = () =>
    (Resources.masterCourseCountries)
        .get()
        .send();
export const registerMasterCourse = ({ sectionId, increaseVersion }) =>
    (Resources.masterCourses)
        .post()
        .withBody({ sectionId, increaseVersion })
        .send();
export const getMasterCourses = ({ accessStatus, countryCode, state }) =>
    (Resources.getMasterCourses
        .post()
        .withBody({ accessStatus, countryCode, state })
        .send());

/**
 * SUBJECTS
 */
export const getSubjects = () =>
    (Resources.subjects
        .get()
        .send());

/**
 * FILE MANAGEMENT
 */
export const getSectionFile = async ({ sectionId }) =>
    getServiceUrl({
        urlPath: API_URLS.GET_SECTION_FILE({
            sectionId
        })
    });
export const checkSectionFile = ({ sectionId }) =>
    (Resources.checkSectionFile)
        .get({ sectionId })
        .send();
export const deleteSectionFile = ({ sectionId }) =>
    (Resources.deleteSectionFile)
        .delete({ sectionId })
        .send();
export const uploadSectionFile = async ({ sectionId, uploadedFile }) => {
    const serviceUrl = await getServiceUrl({
        urlPath: API_URLS.UPLOAD_SECTION_FILE({
            sectionId
        })
    });
    const formData = objectToFormData({ fileObject: uploadedFile });

    // 3p-resource does not yet offer a way to manage form attachments so we create the request ourselves
    // todo: use 3p-resource when available
    return makeFormDataRequest({
        method: 'POST',
        url: serviceUrl,
        params: formData
    });
};



// WEBPACK FOOTER //
// ./app/api.js